import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { guid } from 'app/shared/lib/guid';


@autoinject()
export class DemoEssSelectableListboxPage extends ComponentBase {
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    protected handleClick(event: MouseEvent): void {
        this.ex1Selected = (event.target as HTMLElement).textContent!;
    }

    ////****************** Example 2 ********************************************////
    protected ex1Selected: string = '';
}
